export default "__VITE_ASSET__02a14128__"